import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorProvider } from './contexts/ErrorContext';
import theme from './theme';
import Home from './pages/Home';
import Login from './pages/Login';
import Admin from './pages/Admin';
import DeckSettings from './pages/DeckSettings';
import Docs from './pages/Docs';
import Packages from './pages/Packages';
import PackageDetail from './pages/PackageDetail';
import Config from './pages/Config';
import Messages from './pages/Messages';
import TeamNames from './pages/TeamNames';
import Privacy from './pages/Privacy';

const AdminShell: React.FC = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

const App: React.FC = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <ErrorProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/admin" element={<AdminShell />}>
          <Route path="login" element={<Login />} />
          <Route path="decks" element={<DeckSettings />} />
          <Route path="packages" element={<Packages />} />
          <Route path="packages/:packageId" element={<PackageDetail />} />
          <Route path="docs" element={<Docs />} />
          <Route path="config" element={<Config />} />
          <Route path="messages" element={<Messages />} />
          <Route path="team-names" element={<TeamNames />} />
          <Route index element={<Admin />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorProvider>
  </ThemeProvider>
);

export default App;